
import { BookingStatusKey } from '@/types/booking-status';

export interface ParcelDetails {
  id: string;
  parcel_type: string;
  description: string | null;
  weight: string | null;
  dimensions: {
    length: string;
    width: string;
    height: string;
  } | null;
  value: string | null;
  quantity: number;
  other_type_specification: string | null;
  insurance_enabled: boolean;
}

export interface ContactDetails {
  name: string;
  phone: string;
  email?: string;
}

export interface FulfillmentDetails {
  waybill_number: string;
  tracking_url: string;
  courier_name: string;
  courier_logo_url: string;
  estimated_delivery_date: string | null;
  signature_url: string;
  attachments: string[];
  updates: Array<{
    timestamp: string;
    status: string;
    notes: string;
  }>;
}

export interface BookingDetails {
  id: string;
  status: string; // Back to generic string - validated at runtime
  created_at: string;
  collection_datetime: string | null;
  user_id: string | null;
  org_id: string | null;
  total_parcels_count: number | null;
  collection_address: {
    street: string;
    street2?: string | null;
    city: string;
    province: string;
    postal_code: string;
    country: string;
  } | null;
  delivery_address: {
    street: string;
    street2?: string | null;
    city: string;
    province: string;
    postal_code: string;
    country: string;
  } | null;
  collection_contacts: ContactDetails[];
  delivery_contacts: ContactDetails[];
  parcels: ParcelDetails[];
  
  payment_url: string | null;
  tracking_url: string | null;
  payment_confirmed: boolean | null;
  payment_confirmed_by: string | null;
  payment_confirmed_at: string | null;
  fulfillment_details: FulfillmentDetails | null;
  profiles?: {
    name: string | null;
    phone_number: string | null;
    email: string | null;
  } | null;
}

export interface UseBookingsResult {
  bookings: BookingDetails[];
  isLoading: boolean;
  isFetchingMore: boolean;
  error: Error | null;
  hasMore: boolean;
  fetchMoreBookings: () => void;
  filterBookings: (filter: string) => void;
  activeFilter: string;
  cancelBooking: (bookingId: string) => Promise<boolean>;
  isAdmin: boolean;
  refreshBooking: (bookingId: string) => Promise<BookingDetails | null>;
}

// Constants for pagination
export const PAGE_SIZE = 10;
